import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.ListChange', null, 3);
        tmp0_serialDesc.a1b('wholeList', true);
        tmp0_serialDesc.a1b('old', true);
        tmp0_serialDesc.a1b('new', true);
        this.s3l_1 = tmp0_serialDesc;
      }
      b2j(typeSerial0) {
        return $serializer().i40(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static j40() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.ListChange', $this, 3);
        tmp0_serialDesc.a1b('wholeList', true);
        tmp0_serialDesc.a1b('old', true);
        tmp0_serialDesc.a1b('new', true);
        $this.g40_1 = tmp0_serialDesc;
        return $this;
      }
      k40(encoder, value) {
        var tmp0_desc = this.g40_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.l40_1 == null)) {
          tmp1_output.d15(tmp0_desc, 0, new (ArrayListSerializer())(this.h40_1), value.l40_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.m40_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, this.h40_1, value.m40_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.n40_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, this.h40_1, value.n40_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.k40(encoder, value instanceof ListChange() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.g40_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, new (ArrayListSerializer())(this.h40_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, this.h40_1, tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, this.h40_1, tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, new (ArrayListSerializer())(this.h40_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, this.h40_1, tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, this.h40_1, tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return ListChange().o40(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.g40_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(new (ArrayListSerializer())(this.h40_1)), get_nullable(this.h40_1), get_nullable(this.h40_1)];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.h40_1];
      }
      static i40(typeSerial0) {
        var $this = this.j40();
        $this.h40_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var ListChangeClass;
function ListChange() {
  if (ListChangeClass === VOID) {
    class $ {
      constructor(wholeList, old, new_0) {
        Companion_getInstance();
        wholeList = wholeList === VOID ? null : wholeList;
        old = old === VOID ? null : old;
        new_0 = new_0 === VOID ? null : new_0;
        this.l40_1 = wholeList;
        this.m40_1 = old;
        this.n40_1 = new_0;
      }
      toString() {
        return 'ListChange(wholeList=' + toString(this.l40_1) + ', old=' + toString(this.m40_1) + ', new=' + toString(this.n40_1) + ')';
      }
      hashCode() {
        var result = this.l40_1 == null ? 0 : hashCode(this.l40_1);
        result = imul(result, 31) + (this.m40_1 == null ? 0 : hashCode(this.m40_1)) | 0;
        result = imul(result, 31) + (this.n40_1 == null ? 0 : hashCode(this.n40_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListChange()))
          return false;
        if (!equals(this.l40_1, other.l40_1))
          return false;
        if (!equals(this.m40_1, other.m40_1))
          return false;
        if (!equals(this.n40_1, other.n40_1))
          return false;
        return true;
      }
      static o40(seen0, wholeList, old, new_0, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().s3l_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.l40_1 = null;
        else
          $this.l40_1 = wholeList;
        if (0 === (seen0 & 2))
          $this.m40_1 = null;
        else
          $this.m40_1 = old;
        if (0 === (seen0 & 4))
          $this.n40_1 = null;
        else
          $this.n40_1 = new_0;
        return $this;
      }
    }
    initMetadataForClass($, 'ListChange', ListChange, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    ListChangeClass = $;
  }
  return ListChangeClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance2cclvpun048fq,
};
//endregion

//# sourceMappingURL=ListChange.mjs.map
